import { IIconProps } from '~/types';

const SelectTickIcon = (props: IIconProps) => (
  <svg
    width={34}
    height={34}
    viewBox="0 0 34 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17 33.745c9.205 0 16.667-7.462 16.667-16.667S26.205.41 17.001.41.334 7.873.334 17.078s7.462 16.667 16.667 16.667m9.096-20.905L15.334 23.602 8.322 16.59l2.357-2.357 4.655 4.654 8.405-8.404z"
      fill="#00875A"
    />
  </svg>
);
export default SelectTickIcon;
